import { EventsService } from './events.service'
import { Service } from '@tino-frontend/adapters'
import { WebViewLocalStorage, WebViewParams } from '@types'

function webViewPostMessage<T>(data: T, logError: (e: any) => void) {
  if (window.ReactNativeWebView) {
    try {
      window.ReactNativeWebView.postMessage(JSON.stringify(data))
    } catch (e: any) {
      logError(e)
    }
  }
}

export class WebViewService {
  constructor(
    private readonly events: EventsService,
    private readonly storage: Service
  ) {
    const queryString = window.location.search
    const isReactNativeWebView = window.ReactNativeWebView
    const urlSearchParams = new URLSearchParams(queryString)
    const trackerId =
      urlSearchParams.get('tracker_id') || urlSearchParams.get('trackerId')
    const isWebview =
      isReactNativeWebView && trackerId === WebViewParams.IS_TINO_WEBVIEW
        ? true
        : false

    this.saveIsWebview(isWebview)
  }

  sendMessage(data: object) {
    webViewPostMessage(data, (e) => {
      this.events.error(new Error(e))
    })
  }

  saveIsWebview(isWebview: boolean): Promise<void> {
    return this.storage.post(
      WebViewLocalStorage.TINO_IS_WEBVIEW,
      String(isWebview)
    )
  }

  getIsWebview(): boolean {
    const value = localStorage.getItem(WebViewLocalStorage.TINO_IS_WEBVIEW)
    const valueParsed = value ? JSON.parse(value) : ''

    if (valueParsed.data === 'true') {
      return true
    }

    return false
  }
}
